import React, { memo } from 'react'
import { makeStyles } from 'transfix-ui/core'

export interface IButtonsProps {
  onClear: () => void
  onApply: () => void
  showApplyButton?: boolean
}

const useButtonsStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    margin: '16px 0 0 8px',
    justifyContent: 'flex-end',
  },
}))

export const Buttons = memo<IButtonsProps>(({ onApply, onClear, showApplyButton }) => {
  const styles = useButtonsStyles()
  return (
    <div className={styles.container}>
      <button type='button' className='btn-tertiary' onClick={onClear}>
        Clear
      </button>
      {showApplyButton && (
        <button type='button' className='btn-primary' onClick={onApply}>
          Apply
        </button>
      )}
    </div>
  )
})
